import { render, staticRenderFns } from "./effectuerUnDevisOld.vue?vue&type=template&id=24aba2a1&scoped=true&"
import script from "./effectuerUnDevisOld.vue?vue&type=script&lang=js&"
export * from "./effectuerUnDevisOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24aba2a1",
  null
  
)

export default component.exports